import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetPressArticleResponse } from '../getpresarticleresponse';
import { GetPressArticleRequest } from '../getpressarticlerequest';

@Injectable({
    providedIn: 'root'
})
export class GetPressArticleUseCase extends UseCase<GetPressArticleRequest, Observable<GetPressArticleResponse>> {
    getPressArticleForAProductUrl = '/store/get-pressarticlesforaproduct';
    storeBackendUrl = '';

    constructor(
        _logService: LogService,
        protected override _http: HttpClient,
        private _apiRequestService: ApiRequestService,
        @Inject('STORE_BACKEND_URL') _storeBackendUrl: string
    ) {
        super(_logService, _http);
        this.storeBackendUrl = _storeBackendUrl;
    }

    protected override executeBusinessLogic(request: void | GetPressArticleRequest): void | Observable<GetPressArticleResponse> {
        return this._apiRequestService.sendRequest(this.storeBackendUrl, request, true, this.getPressArticleForAProductUrl);
    }
}
